/**
 * @module StepperActions
 * @description Barra de acciones inferior del stepper wizard.
 * Renderiza condicionalmente:
 * - Botón de retroceso (oculto en modo pago rápido con idpago en URL)
 * - Paso 3: Widget de checkout ePayco para procesar el pago
 * - Pasos 1-2: Botón "Continuar" que ejecuta validaciones antes de avanzar
 *
 * El botón "Continuar" tiene doble función:
 * 1. onClick -> handleContinuar(): ejecuta validaciones asíncronas del paso actual
 * 2. type="submit" -> submitStep de Formik: avanza en el stepper si no hay errores
 */

import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePagosOnline } from "../PagosOnlineContext";
import {
    valortotalDocumentosSeleccionados,
    baseUrl,
} from "../../../helpers";
import { EpaycoCheckOut } from "../../../modules/comfeModules";

const StepperActions: FC = () => {
    const {
        stepIndex,
        prevStep,
        handleContinuar,
        loading,
        estado,
        setEstado,
        setPantallaBloqueada,
        stepper,
        continuar_btn,
        parametrosURL,
    } = usePagosOnline();

    return (
        <div className={"d-flex flex-stack pt-10"}>
            {/* ── Botón de retroceso ── */}
            <div className={"me-2 "}>
                <button
                    onClick={prevStep}
                    type="button"
                    className={
                        "btn btn-comfe-light me-3 rounded-pill " +
                        (parametrosURL.idpago ? "d-none" : "")
                    }
                    data-kt-stepper-action="previous"
                    disabled={loading}
                >
                    <FontAwesomeIcon icon={"arrow-left"} />
                </button>
            </div>

            <div className="mb-4">
                {stepIndex === 3 ? (
                    /**
                     * Paso 3: Widget de ePayco para procesamiento de pago.
                     * Recibe el token del servicio, datos del usuario y URLs de respuesta/confirmación.
                     * El monto se calcula dinámicamente según documentos seleccionados.
                     */
                    <div id="targetEpayco">
                        <EpaycoCheckOut
                            email={estado.correo}
                            amount={valortotalDocumentosSeleccionados(estado)}
                            name={
                                estado.referencias[estado.referenciaActiva]?.descrip
                            }
                            descrip={
                                estado.referencias[estado.referenciaActiva]?.descrip
                            }
                            estado={estado}
                            setEstado={setEstado}
                            stpb={setPantallaBloqueada}
                        ></EpaycoCheckOut>
                    </div>

                ) : (
                    /**
                     * Pasos 1-2: Botón "Continuar" con validaciones.
                     * En paso 2 se deshabilita si no hay referencias seleccionadas.
                     * Muestra spinner de carga cuando loading === true.
                     */
                    <button
                        type="submit"
                        className={
                            "btn btn-comfe me-3 rounded-pill "
                        }
                        ref={continuar_btn}
                        onClick={() => {
                            handleContinuar();
                        }}
                        disabled={
                            stepper.current?.currentStepIndex ===
                            2 &&
                            Object.keys(estado.referencias)
                                .length === 0
                        }
                    >
                        <span className="indicator-label">
                            {stepper.current?.currentStepIndex !==
                                stepper.current?.totatStepsNumber! -
                                1 &&
                                loading === false &&
                                "Continuar "}
                            {stepper.current?.currentStepIndex ===
                                stepper.current?.totatStepsNumber! -
                                1 &&
                                loading === false &&
                                "Continuar "}
                            {loading && ""}
                            {loading ? (
                                <span
                                    className="indicator-progress"
                                    style={{ display: "block" }}
                                >
                                    Por favor espere...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            ) : (
                                <FontAwesomeIcon
                                    icon={"arrow-right"}
                                />
                            )}
                        </span>
                    </button>
                )}
            </div>
        </div>
    );
};

export { StepperActions };
